require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/Dialog/DialogActions.tsx";

var DialogActions = function (_React$Component) {
  (0, _inherits2["default"])(DialogActions, _React$Component);

  function DialogActions() {
    (0, _classCallCheck2["default"])(this, DialogActions);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(DialogActions).apply(this, arguments));
  }

  (0, _createClass2["default"])(DialogActions, [{
    key: "render",
    value: function render() {
      return React.createElement(_reactNative.View, (0, _extends2["default"])({}, this.props, {
        style: [styles.container, this.props.style],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 49
        }
      }), React.Children.map(this.props.children, function (child) {
        return React.isValidElement(child) ? React.cloneElement(child, {
          compact: true
        }) : child;
      }));
    }
  }]);
  return DialogActions;
}(React.Component);

(0, _defineProperty2["default"])(DialogActions, "displayName", 'Dialog.Actions');

var styles = _reactNative.StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: 8
  }
});

var _default = DialogActions;
exports["default"] = _default;